import { List } from '@fluentui/react';
import * as React from 'react';
import { CustomerFilterType, ShortCustomerModel } from '../../models/CustomerModel';
import CustomerRowView from './CustomerRowView';

type CustomerGridProps = {
    customers: ShortCustomerModel[];
    onSelect: (customer: ShortCustomerModel) => void;
    filterType: CustomerFilterType;
}

export default function CustomerGridView({ customers, onSelect, filterType }: CustomerGridProps) {
    const onRenderCell = (customer?: ShortCustomerModel, index?: number, isScrolling?: boolean) => {
        if (customer == null) return <>empty</>;

        return <div className="pointer pv-5" onClick={() => onSelect(customer)}>
            <CustomerRowView key={customer.id} customer={customer} filterType={filterType} />
        </div>;
    }

    return <div className="ms-Grid">
        <List items={customers} onRenderCell={onRenderCell} onShouldVirtualize={() => false} />
    </div>;
}